var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"p-0",attrs:{"no-body":""}},_vm._l((_vm.abas),function(aba,i){return _c('accordion',{key:aba.titulo,attrs:{"id":aba.xml,"title":aba.titulo,"disabled":aba.desabilitado() || !aba.componente,"sub":"","accordion":"sub_aneel"},scopedSlots:_vm._u([{key:"append-title",fn:function(){return [(aba.preenchido)?_c('div',[_c('b-badge',{staticClass:"ml-2",attrs:{"variant":"success"}},[_vm._v("Preenchido")])],1):_vm._e()]},proxy:true}],null,true)},[_c(aba.componente,{ref:aba.xml,refInFor:true,tag:"component",attrs:{"projeto-editavel":_vm.projetoEditavel,"id-upload":("up" + i),"projeto":_vm.projeto,"itens":aba.objeto,"itens2":aba.objeto2},on:{"salvar":function($event){return _vm.salvarXML(
            $event,
            aba,
            aba.componente == 'comprovante-xml'
              ? 'Deseja salvar o comprovante?'
              : $event.mensagemConfirmacao
              ? $event.mensagemConfirmacao
              : 'Deseja gerar XML?',
            aba.componente == 'comprovante-xml'
              ? 'Comprovante salvo com sucesso'
              : 'XML gerado com sucesso'
          )},"deletar":function($event){return _vm.deletarXML(
            $event,
            aba,
            false,
            aba.componente == 'comprovante-xml'
              ? 'Deseja excluir o comprovante?'
              : 'Deseja excluir o XML?',
            aba.componente == 'comprovante-xml'
              ? 'Comprovante excluído com sucesso'
              : 'XML excluído com sucesso'
          )},"deletar2":function($event){return _vm.deletarXML($event, aba, true)},"download":function($event){return _vm.download($event, aba)},"newDownload":function($event){return _vm.downloadNew($event, aba)},"download2":function($event){return _vm.download($event, aba, true)}}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }